export default "__VITE_ASSET__OByo2VkP__"